"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

exports["default"] = function (size, color) {
  return react_1["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    viewBox: "0 0 20 16.3"
  }, react_1["default"].createElement("path", {
    fill: color,
    d: "M20,1.9c-0.7,0.3-1.5,0.5-2.4,0.6c0.9-0.5,1.5-1.3,1.8-2.3c-0.8,0.5-1.7,0.8-2.6,1c-1.5-1.7-4.1-1.7-5.8-0.2\nc-0.8,0.8-1.3,1.9-1.3,3c0,0.3,0,0.6,0.1,0.9C6.5,4.9,3.4,3.3,1.4,0.8C1,1.4,0.8,2.1,0.8,2.8c0,1.4,0.7,2.7,1.8,3.4\nC2,6.2,1.3,6,0.8,5.7v0.1c0,2,1.4,3.6,3.3,4C3.5,10,2.8,10,2.2,9.9c0.5,1.7,2.1,2.8,3.8,2.8c-1.5,1.1-3.2,1.8-5.1,1.8\nc-0.3,0-0.7,0-1-0.1c1.9,1.2,4.1,1.8,6.3,1.8c6.4,0,11.6-5.1,11.7-11.5c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5\nC18.8,3.5,19.4,2.8,20,1.9L20,1.9L20,1.9z"
  }));
};